import React from 'react';
import { useTranslation } from 'react-i18next';
import {TrackEvent} from '../../services/gtmEvents';

const CardSeeMore = ({cardType, description, url}) => {
  let cardTypeClass = 'card';
  const { t } = useTranslation();

  if (cardType !== undefined && cardType.trim() !== '') {
    cardTypeClass += ' card-' + cardType;
  }

  return <div className={cardTypeClass}>
    <div className={'see-more'}>
      <a href={url} onClick={() => TrackEvent('Navigation', 'See more', description)} className={'see-more-plus'}>+</a>
      <a href={url} onClick={() => TrackEvent('Navigation', 'See more', description)} className={'see-more-text'}>{t('see_more')}</a>
      <div className={'see-more-description'}>{description}</div>
      <div style={{lineHeight: '135px'}}>&nbsp;</div>
    </div>
  </div>;
};

export default CardSeeMore;
